export const filterOptions = [
  {
    value: '0',
    label: 'All'
  },
  {
    value: '1',
    label: 'Blu Bar Ambassador Objective'
  },
  {
    value: '2',
    label: 'Price IT'
  },
  {
    value: '3',
    label: 'Sell IT'
  },
  {
    value: '4',
    label: 'Price IT +'
  },
  {
    value: '5',
    label: 'Blu Bar Sell It'
  }
];

export const statusOptions = [
  {
    value: '0',
    label: 'All'
  },
  {
    value: '1',
    label: 'Live'
  },
  {
    value: '2',
    label: 'Ended'
  }
];
